import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import React from "react";
import { createRoot } from "react-dom/client";
import pageTemplate from "text!../../../templates/library/libraryShellPageTemplate.html";
import LibraryPage from "../../components/library/LibraryPage";

const LibraryShellPageView = Backbone.View.extend({
  template: _.template(pageTemplate),

  events: function () {
    const events = {
      "click #homeHeaderButton": "onHomeButtonSelected",
    };

    if (this._shellConfig?.showActionButton) {
      events["click #pageActionButton"] = "onActionButtonSelected";
    }

    return events;
  },

  initialize: function (options) {
    this._reactRoot = null;
    this._shellConfig = options?.shellConfig || {};
  },

  onHomeButtonSelected: function () {
    this.trigger("showHomePopup");
  },

  onActionButtonSelected: function () {
    if (this._shellConfig?.actionEventName) {
      this.trigger(this._shellConfig.actionEventName);
    }
  },

  _getPageTitle: function () {
    return this._shellConfig?.pageTitle || "";
  },

  _updatePageTitle: function () {
    this.$el.find("#pageHeaderTitleWrapper").text(this._getPageTitle());
  },

  _onPageShow: function () {
    this._updatePageTitle();
    this.trigger("pageshow");
  },

  _onPageHide: function () {
    this.trigger("pagehide");
  },

  _onPageRemoved: function () {
    if (this._reactRoot) {
      this._reactRoot.unmount();
      this._reactRoot = null;
    }

    this.undelegateEvents();
    this.$el.removeData().unbind();
    this.stopListening();
  },

  _renderLibraryPage: function () {
    const reactContainer = this.$el.find("#libraryReactRoot").get(0);
    if (!reactContainer) return;

    if (!this._reactRoot) {
      this._reactRoot = createRoot(reactContainer);
    }

    const ReactComponent = this._shellConfig?.reactComponent || LibraryPage;
    const reactProps = {
      section: this._shellConfig?.section || "library",
      pageMode: this._shellConfig?.pageMode || "default",
      ...(this._shellConfig?.reactProps || {}),
    };

    this._reactRoot.render(React.createElement(ReactComponent, reactProps));
  },

  render: function () {
    this.$el.html(this.template({
      pageId: this._shellConfig?.pageId,
      pageTitle: this._getPageTitle(),
      showActionButton: this._shellConfig?.showActionButton === true,
      actionLabel: this._shellConfig?.actionLabel || "",
      actionIconClassName: this._shellConfig?.actionIconClassName || "ion-ios7-plus-empty",
    }));
    this.setElement(this.$el.find("div").first());
    this.$el.page();
    this._updatePageTitle();

    this._renderLibraryPage();

    this.$el
      .children(
        ".ui-header:not(.ui-header-fixed), .ui-content:not(.ui-popup), .ui-footer:not(.ui-footer-fixed)"
      )
      .wrapAll("<div class='ui-panel-wrapper'></div>");

    this.$el.on("pageshow", this._onPageShow.bind(this));
    this.$el.on("pagehide", this._onPageHide.bind(this));
    this.$el.on("remove", this._onPageRemoved.bind(this));

    return this;
  },
});

export default LibraryShellPageView;
